const getInitialsMessage = (name) => {
    if (typeof name === "string") {
        const nameParts = name.split(" ");
        return nameParts.length === 1
            ? nameParts[0][0].toUpperCase()
            : (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase();
    } else if (name && name.fullName) {
        const nameParts = name.fullName.split(" ");
        return nameParts.length === 1
            ? nameParts[0][0].toUpperCase()
            : (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase();
    }
    return "";
};

export default getInitialsMessage;
